import { FormFieldData } from "modules/forms";
import { IMapper } from "shared/types/IMapper";
import { CreateIssueRequest } from "../mutations/create-issue.mutations.types";
import { ObservationrecordOriginEnum } from "shared/enums/ObservationrecordOrigin.enum";
import i18next from 'i18next';
import { ObservationLanguageEnum } from "shared/enums/ObservationLanguageEnum";
import { IssueEntity } from "shared/types/domain/IssueEntity";

export class CreateIssueRequestMapper implements IMapper<FormFieldData<IssueEntity>, CreateIssueRequest> {
    map(entity: FormFieldData<IssueEntity>): CreateIssueRequest {
        return {
            concernLevel: entity.concernLevel,
            depotPcId: entity.depotPcId,
            whatHappened: entity.whatHappened,
            howToStop: entity.howToStop,
            reporterType: entity.reporterType.toUpperCase(),
            anonymousEntry: entity.anonymousEntry ?? false,
            contactName: entity.reporterContactName,
            contactPhoneNumber: entity.reporterPhoneNumber,
            contactEmail: entity.reporterEmail,
            createdFrom: ObservationrecordOriginEnum.WebApp,
            selectedLanguage: ObservationLanguageEnum[i18next.language.toUpperCase() as keyof typeof ObservationLanguageEnum],
            enhancements: {
                processId: entity.processId,
                reachId: entity.reachId
            }
        }
    };
}